import { render, staticRenderFns } from "./outside-click.vue?vue&type=template&id=179ee816&"
import script from "./outside-click.vue?vue&type=script&lang=js&"
export * from "./outside-click.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports